/* eslint-disable */
import storeApis from "../../api/storeApi";
import * as types from "../../constants/AccountActionTypes";
import { toast } from "react-toastify";
import Toast from "../../components/assetLibComponents/shared/Toast";
import { getFollowListSetup, getTrackingList } from "./intentAction";

const ACCOUNT_LIST = "accounts/list";

//SET Unauthorization Status
export const setAccountUnauthorized = () => {
    return (dispatch) => {
        dispatch({ type: "UNAUTHORIZED_ACCOUNT", payload: null });
    };
};

//Fetch Contacts List
export const fetchAccountList = (authToken, search, offset, sort,startDate,endDate) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
                ACCOUNT_LIST,
                {
                    search: search,
                    page_no: offset,
                    sort : sort,
                    from_date: startDate,
                    to_date: endDate,
                },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                    // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
                        dispatch({
                            type: "UNAUTHORIZED_ACCOUNT",
                            payload: response.data.statusCode,
                        });
                    // } else {
                    //     // Toast(response.data.message, "E");
                    // }
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                } else {
                    dispatch({ type: types.FETCH_ACCOUNT_LIST, payload: response.data });
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
            }
        } catch (err) {
            // Toast(err.response.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: "UNAUTHORIZED_ACCOUNT", payload: err.response.status });
        }
    };
};

//get user activity
export const appUserAccountActivity = (authToken, accountId, flag) => {
    return async (dispatch) => {
        if(flag === null){dispatch({ type: "TOGGLE_LOADING", payload: true });}
        try {
            const response = await storeApis.post(
                "accounts/details",
                {
                    account_id: accountId
                },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                    // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
                        dispatch({
                            type: "UNAUTHORIZED_CRM",
                            payload: response.data.statusCode,
                        });
                    // } else {
                    //     // Toast(response.data.message, "E");
                    // }
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                } else {
                    await dispatch({ type: types.USER_ACTIVITY_ACCOUNT_DETAILS, payload: response?.data?.data });
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
            }
        } catch (err) {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: "UNAUTHORIZED_CRM", payload: err.response.status });
        }
    };
}; 

export const editAccountData = (authToken,id,payload) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
                "accounts/update",
                {
                    account_id: id,
                    response: payload,
                },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                    // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
                        dispatch({
                            type: "UNAUTHORIZED_CRM",
                            payload: response.data.statusCode,
                        });
                    // } else {
                    //     // Toast(response.data.message, "E");
                    // }
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                } else {
                    dispatch(appUserAccountActivity(authToken, id , null));
                    Toast(response.data.message, "S");
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
            }
        } catch (err) {
            // Toast(err.response.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: "UNAUTHORIZED_CRM", payload: err.response.status });
        }
    };
};


export const fetchStar = (authToken) => {
    return async (dispatch) => {
      // dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.get(
          "intent/follow-account-list",
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_ACCOUNT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            dispatch({ type: "STAR_DATA", payload: response.data });
            // dispatch({ type: "CHAT_DESIGN_DATA", payload: response.data.details });
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_ACCOUNT",
          payload: err.response.status,
        });
      }
    };
  };
export const postStar = (authToken,arr,type,point) => {
    return async (dispatch) => {
      // dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post(
          "intent/follow-account",
          {
            account_id:arr,
            type:type
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_ACCOUNT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            if(point=="track"){
              dispatch(getTrackingList(authToken,"",""));
              dispatch(getFollowListSetup(authToken));
            }else{
              dispatch(fetchAccountList(authToken,"",1));
            }
            // dispatch({ type: "STAR_DATA", payload: response.data });
            // dispatch({ type: "CHAT_DESIGN_DATA", payload: response.data.details });
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_ACCOUNT",
          payload: err.response.status,
        });
      }
    };
  };
export const postRemoveStar = (authToken,arr,type,point) => {
    return async (dispatch) => {
      // dispatch({ type: "TOGGLE_LOADING", payload: true });
      try {
        const response = await storeApis.post(
          "intent/unfollow-account",
          {
            account_id:arr,
            type:type

          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_ACCOUNT",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // Toast(response.data.message, "E");
          } else {
            if(point=="track"){
              dispatch(getTrackingList(authToken,"",""));
              dispatch(getFollowListSetup(authToken));
            }else{
              dispatch(fetchAccountList(authToken,"",1));
            }
            // dispatch({ type: "STAR_DATA", payload: response.data });
            // dispatch({ type: "CHAT_DESIGN_DATA", payload: response.data.details });
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        dispatch({
          type: "UNAUTHORIZED_ACCOUNT",
          payload: err.response.status,
        });
      }
    };
  };



